import React, { useEffect, useState } from "react";
import { Button, notification, Spin, Tooltip } from "antd";
import { SvgIcons } from "Icon/SvgIcons";
import { formatNumber, trimStr } from "utils";
import arrowdown from "../../images/arrowdown.svg";
import removeicon from "../../images/remove.svg";
import refreshicon from "../../images/refresh2.svg";
import ExportConfigButton from "components/search/ExportConfig";
import { useDispatch, useSelector } from "react-redux";
import { changeIsNamedSearch, setActiveStep } from "store/slices/searcSlice";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { cancelSearch } from "api/search.api";
import { BsStopFill } from "react-icons/bs";
import AIFiltersPopupNew from "components/HRFlow/common/AIFiltersPopupNew";
const BsStopCircleSin = BsStopFill as unknown as React.FC as any;


const SearchCandidatesHeader = ({
  searchResult,
  searchResultStat,
  isSearchSave,
  handleDeleteSearch,
  handleSaveSearch,
  refreshResult,
  pollStart,
  candidateLoading,
  jobId,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchId, gSearchId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isHovered, setIsHovered] = useState(false);
  const [isFiltersModalShow, setIsFiltersModalShow] = useState(false);

  const handleOpenModal = () => {
    setIsFiltersModalShow(true);
  };
  const handleCloseModal = () => {
    setIsFiltersModalShow(false);
  };

  const search_id = searchParams.get('search_id');

  const handleEditSearch = () => {
    if (searchId && jobId) {
      handleOpenModal();
      searchParams.set("job-id", jobId);
      searchParams.set("searchId", searchId);
      setSearchParams(searchParams);
    }
  };

  const stopSearch = async () => {
    try {
      if (search_id) {
        const response = await cancelSearch(search_id);
        notification.success({
          message: "Success",
          description: "Stopped search",
        });
      }
    } catch (error) {
      console.log("Error while stopping search: ", error);
    }
  };

  const isNamedSearch = useSelector((state: any) => state.search.isNamedSearch);

  const defaultStopIcon = (
    <svg width="20" height="20" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="10" width="80" height="80" rx="20" stroke="#A78BFA" strokeWidth="4" />
      <rect x="30" y="30" width="40" height="40" rx="10" stroke="#A78BFA" strokeWidth="4" />
    </svg>
  );

  const hoverStopIcon = (
    <svg width="20" height="20" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" rx="20" fill="#A78BFA" />
      <rect x="30" y="30" width="40" height="40" rx="10" stroke="white" strokeWidth="4" />
    </svg>
  );

  useEffect(() => {
    if (searchResult) {
      dispatch(changeIsNamedSearch(searchResult?.is_name_search));
    }
  }, [searchResult]);

  // const poll = ({
  //     interval,
  //     maxAttempts,
  // }: {
  //     // fn: any;
  //     // validate: any;
  //     interval: number;
  //     maxAttempts: number;
  // }) => {

  //     let attempts = 0;
  //     let alreadyRefreshed = false;
  //     setPollStart(true);
  //     const executePoll = async (resolve: any, reject: any) => {
  //         if (interval && interval % 10 === 0)
  //             getCandidateCount({
  //                 variables: {
  //                     configId: parseInt(searchLogId),
  //                     token: readToken(),
  //                 },
  //             });
  //         const result: any = await getSearchStats(searchId);
  //         attempts = attempts + 1;
  //         setTotalCandidate(result.total_candidates);
  //         setTotalPages(result.total_pages);
  //         if (
  //             (!candidateProfiles.length &&
  //                 result.total_candidates &&
  //                 !alreadyRefreshed) ||
  //             (candidateProfiles.length &&
  //                 candidateProfiles.length < pageCount * page)
  //         ) {
  //             alreadyRefreshed = true;
  //             loadMoreData(true);
  //         }

  //         if (
  //             (maxAttempts && attempts === maxAttempts) ||
  //             result.search_status == false ||
  //             (window.location.pathname &&
  //                 window.location.pathname.indexOf("search/search-result/") === -1)
  //         ) {
  //             console.log("polling Stop");
  //             setPollStart(false);
  //             return resolve(result);
  //             // return reject(new Error("Exceeded max attempts"));
  //         } else {
  //             setTimeout(executePoll, interval, resolve, reject);
  //         }
  //     };

  //     return new Promise(executePoll);
  // };

  // useEffect(() => {
  //     if (candidateList && candidateList.search_status) {
  //         poll({ interval: 3000, maxAttempts: 70 }).then((data: any) => {
  //             setTotalCandidate(data.total_candidates);
  //             setTotalPages(data.total_candidates / 10);
  //         });
  //     }

  //     setTotalCandidate(candidateList.count);
  // }, [searchId]);
  return (
    <div className="py-2.5 px-6 bg-white flex justify-between items-center bottom-1 border-b border-main-border flex-wrap">
      <div className="flex gap-2 items-center w-full xl:w-2/5">
        <div className="flex items-center gap-1">
          {/* <p className="text-text-heading font-bold text-xl">Results:</p> */}
          <span className="text-text-secondary font-bold text-lg">
            {searchResult?.search_title
              ? trimStr(searchResult?.search_title + "-" + searchResult?.job?.title, 150)
              : ""}
          </span>
        </div>
        {/* <Dropdown overlay={menu} trigger={["click"]}>
        <button className="py-1 px-3 bg-bg-secondary flex items-center gap-1 border border-gray-300 rounded-md text-text-quaternary">
          +5 job titles <img src={arrowdown} />
        </button>
      </Dropdown> */}
      </div>

      <div className="w-full xl:w-3/5 flex items-center gap-3 xl:justify-end mt-2 xl:mt-0">
        <p className="text-text-quaternary font-medium text-nowrap">
          {/* <Spin size="small"
                        spinning={pollStart}
                        className="mr-3"
                    /> */}
          {formatNumber(searchResultStat?.total_candidates ?? 0)} Matches
        </p>
        <div className="flex gap-3">
          {isSearchSave && (
            <Tooltip title="Delete Search">
              <button onClick={handleDeleteSearch}>
                <img src={removeicon} />
              </button>
            </Tooltip>
          )}
          <Tooltip title="Refresh Search">
            <button
              onClick={() => {
                refreshResult();
              }}
              style={{ width: "20px" }}
            >
              <img
                src={refreshicon}
                className={`${candidateLoading || pollStart || searchResultStat.search_status
                  ? "animate-spin"
                  : ""
                  }`}
              />
            </button>
          </Tooltip>
          {(pollStart || searchResultStat.search_status) && <Tooltip title="Stop Search">
            <Button
              icon={<BsStopCircleSin className="video-controller-icon" />}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                stopSearch();
              }}
              style={{ height: 15, width: 20, top: 10, border: 0 }}
            >
            </Button>
          </Tooltip>}
          {searchResult?.search_config && !isNamedSearch && (
            <div className="w-fit">
              <ExportConfigButton
                searchConfig={searchResult?.search_config}
                title="Export Search Config"
                isDisabled={searchResultStat?.total_candidates === 0}
              ></ExportConfigButton>
            </div>
          )}
          <Button icon={<EditOutlined />} onClick={handleEditSearch} disabled={isNamedSearch}>
            Edit
          </Button>
        </div>
        <Button
          // type="primary"
          className="flex items-center gap-2 text-white px-3 py-2 bg-[#845dda] border border-[#7F56D9]"
          onClick={handleSaveSearch}
          // icon={isSearchSave ? SvgIcons.filledSaveSvg : SvgIcons.saveSvg}
          icon={isSearchSave ?
            <>
              <svg width={20} height={20} viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.16669 6.5C4.16669 5.09987 4.16669 4.3998 4.43917 3.86502C4.67885 3.39462 5.06131 3.01217 5.53171 2.77248C6.06649 2.5 6.76656 2.5 8.16669 2.5H11.8334C13.2335 2.5 13.9336 2.5 14.4683 2.77248C14.9387 3.01217 15.3212 3.39462 15.5609 3.86502C15.8334 4.3998 15.8334 5.09987 15.8334 6.5V17.5L10 14.1667L4.16669 17.5V6.5Z"
                  stroke="currentColor"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </> :
            <>
              <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.16669 6.5C4.16669 5.09987 4.16669 4.3998 4.43917 3.86502C4.67885 3.39462 5.06131 3.01217 5.53171 2.77248C6.06649 2.5 6.76656 2.5 8.16669 2.5H11.8334C13.2335 2.5 13.9336 2.5 14.4683 2.77248C14.9387 3.01217 15.3212 3.39462 15.5609 3.86502C15.8334 4.3998 15.8334 5.09987 15.8334 6.5V17.5L10 14.1667L4.16669 17.5V6.5Z"
                  stroke="currentColor"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          }
        >
          Save Search
        </Button>
        {/* <button
          {formatNumber(searchResultStat?.total_candidates ?? 0)} Matches
        </p>
        <div className="flex gap-5">
          {isSearchSave && (
            <Tooltip title="Delete Search">
              <button onClick={handleDeleteSearch}>
                <img src={removeicon} />
              </button>
            </Tooltip>
          )}
          <Tooltip title="Refresh Search">
            <button
              onClick={() => {
                refreshResult();
              }}
            >
              <img
                src={refreshicon}
                className={`${
                  candidateLoading ||
                  pollStart ||
                  searchResultStat.search_status ||
                  searchResult?.search_status
                    ? "animate-spin"
                    : ""
                }`}
              />
            </button>
          </Tooltip>
          {searchResult?.search_config && (
            <div className="w-fit">
              <ExportConfigButton
                searchConfig={searchResult?.search_config}
                title="Export Search Config"
              ></ExportConfigButton>
            </div>
          )}
          <Button icon={<EditOutlined />} onClick={handleEditSearch} style={{ display: "none" }}>
            Edit
          </Button>
        </div>
        <Button
          type="primary"
          onClick={handleSaveSearch}
          icon={isSearchSave ? SvgIcons.filledSaveSvg : SvgIcons.saveSvg}
        >
          Save Search
        </Button>
        {/* <button
                    className="relative overflow-hidden font-semibold  text-sm text-white rounded-md py-2 px-3 shadow-md bg-[#845dda] border border-[#7F56D9] after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-md after:border after:border-[#8e69dd] flex gap-1"
                    onClick={handleSaveSearch}
                >
                    {isSearchSave ? SvgIcons.filledSaveSvg : SvgIcons.saveSvg} Save Search
                </button> */}
      </div>
      <AIFiltersPopupNew
        handleCloseModal={handleCloseModal}
        open={isFiltersModalShow}
        isFilterQuery={true}
      />
    </div>
  );
};

export default SearchCandidatesHeader;
